import React from 'react';
import {
  Button,
  ButtonFill,
  Icon,
  FdsIcon,
  Container,
  ComponentAlign,
  ComponentShadow,
  ContainerAnimation,
  Orientation,
} from '@tcc/fds';
import styles from './styles.css';

interface Props {
  show: boolean;
  onDismiss: () => void;
  message: string;
  icon: React.ReactNode;
  dismissLabel: string;
  mainActionLabel?: string;
  onMainActionClick?: () => void;
}

export const MarketingBanner = ({
  show,
  onDismiss,
  message,
  icon,
  dismissLabel,
  mainActionLabel,
  onMainActionClick,
}: Props) => {
  if (!show) return null;

  return (
    <Container
      orientation={Orientation.Horizontal}
      align={ComponentAlign.Center}
      shadow={ComponentShadow.Subtle}
      animation={ContainerAnimation.Height}
      className={styles.container}
      testId="marketing-banner-container"
    >
      <div className={styles.iconContainer}>
        {icon || <Icon icon={FdsIcon.Settings} testId="marketing-banner-default-icon" />}
      </div>
      <div className={styles.messageContainer}>
        <span>{message}</span>
      </div>
      <div className={styles.actionsContainer}>
        {mainActionLabel && typeof onMainActionClick === 'function' ? (
          <Button
            fill={ButtonFill.Outline}
            onClick={onMainActionClick}
            className={styles.ctaButton}
            testId="marketing-banner-cta"
          >
            {mainActionLabel}
          </Button>
        ) : null}
        <Button fill={ButtonFill.Solid} onClick={onDismiss} role="button" testId="marketing-banner-dismiss">
          {dismissLabel}
        </Button>
      </div>
    </Container>
  );
};
